import { render, staticRenderFns } from "./SupplierGoods.vue?vue&type=template&id=4acd4bb6&scoped=true&"
import script from "./SupplierGoods.vue?vue&type=script&lang=ts&"
export * from "./SupplierGoods.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierGoods.vue?vue&type=style&index=0&id=4acd4bb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd4bb6",
  null
  
)

export default component.exports